import React, { Component } from 'react'
import { Button, Spin } from 'hljd'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import Store from './store'
import { hashHistory } from 'react-router'
import { HeaderView } from '@merchant-backend/common-components'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.getMerchantInfo()
  }

  modify = () => {
    hashHistory.push('/localMerchant/siyiGroup')
  }

  render() {
    const { merchantInfo, loading } = this.store
    const { create_group } = merchantInfo || {}
    const {
      examine,
      status,
      register_improve_submit_time,
      register_improve_review_time,
      reason,
      certify_fail_reason,
      phone,
      default_password
    } =
      create_group || {}

    // examine=1 已有审核通过的团队
    // examine！=1 且 status 0待审核 1拒绝

    return (
      <HeaderView>
        <Spin spinning={loading}>
          <div className={styles.wrap}>
            {examine != 1 &&
              status == 0 && (
                <div className={styles.audit}>
                  <img
                    src="https://qnm.hunliji.com/o_1d8fb308a1if412tr1db71pg71pdge.png"
                    width={70}
                    height={70}
                  />
                  <p className={styles.txt}>团队注册申请审核中</p>
                  {register_improve_submit_time && (
                    <p className={styles.tips}>
                      （{register_improve_submit_time} 提交）
                    </p>
                  )}

                  <Button className={styles.btn} onClick={this.modify}>
                    修改申请
                  </Button>
                  {register_improve_review_time ? (
                    <p className={styles.tips}>
                      预计在 {register_improve_review_time} 前完成审核
                    </p>
                  ) : (
                    <p className={styles.tips}>预计在1~2个工作日内完成审核</p>
                  )}
                  <p className={styles.tips}>
                    （17点后及非工作日提交顺延至下一工作日审核）
                  </p>
                </div>
              )}

            {examine != 1 &&
              status == 1 && (
                <div className={styles.fail}>
                  <img
                    src="https://qnm.hunliji.com/o_1d8fb1l64cdlge813437or1vr49.png"
                    width={70}
                    height={70}
                  />
                  <p className={styles.txt}>抱歉，团队注册审核未通过</p>
                  <p className={styles.tips}>
                    {reason && `店铺信息未通过原因：${reason}。`}
                  </p>

                  <p className={styles.tips}>
                    {certify_fail_reason &&
                      `实名认证未通过原因：${certify_fail_reason}。`}
                  </p>

                  <span className={styles.defaultStyle}>
                    <Button
                      className={styles.btn}
                      onClick={() =>
                        window.open(
                          '//www.hunliji.com/p/wedding/Public/wap/m/audit-rules/index.html',
                          '',
                          `height=667, width=375, top=${(window.screen.height -
                            667) /
                            2},left=${(window.screen.width - 375) / 2}`
                        )
                      }
                    >
                      查看审核标准
                    </Button>
                  </span>

                  <Button
                    className={styles.btn}
                    style={{ marginLeft: 10 }}
                    onClick={this.modify}
                  >
                    修改申请
                  </Button>
                </div>
              )}

            <hr />

            <p style={{ fontSize: 18, marginBottom: 40 }}>
              您当前已可使用以下账号密码登录团队
            </p>

            <p>账号：{phone}</p>
            <p>默认密码：{default_password}</p>
          </div>
        </Spin>
      </HeaderView>
    )
  }
}
